"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineStatusLabel = void 0;
const helpers_1 = require("../../helpers");
const getOrderLineStatusLabel = (item) => {
    switch (item.status) {
        case helpers_1.OrderLineStatus.DRAFT:
            return {
                label: "Draft",
                className: "text-grey4 text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.PENDING_CLIENT_APPROVAL:
            return {
                label: "Pending client approval",
                className: "text-blue text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.PENDING:
            return {
                label: "Pending",
                className: "text-blue text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.URGENT_ACTION_REQUIRED:
            return {
                label: "Urgent action required",
                className: "text-orange text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.WAITING_TO_SEND:
            return {
                label: "Waiting to send",
                className: "text-orange text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.WAITING_FOR_CLIENT_TRANSFER_INFO:
            return {
                label: "Waiting for client transfer info",
                className: "text-orange text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.MISSING_SUPPLIER_EMAIL:
            return {
                label: "Missing supplier email",
                className: "text-red text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER:
            return {
                label: "Waiting for supplier",
                className: "text-orange text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.WAITING_FOR_SUPPLIER_OVERDUE:
            return {
                label: "Waiting for supplier overdue",
                className: "text-red text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.CONFIRMED_PAID:
            return {
                label: "Confirmed & Paid",
                className: "text-green text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.CONFIRMED:
            return {
                label: "Confirmed",
                className: "text-green text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.CHANGE_REQUESTED:
            return {
                label: "Change requested",
                className: "text-orange text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.UPDATE_PENDING:
            return {
                label: "Update pending",
                className: "text-orange text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.ALTERNATIVE_OFFERED:
            return {
                label: "Alternative offered",
                className: "text-blue text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.ALTERNATIVE_OFFERED_OVERDUE:
            return {
                label: "Alternative offered overdue",
                className: "text-red text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.CANCELLED:
            return {
                label: "Cancelled",
                className: "text-black90 text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.CANCELLED_UNAVAILABLE:
            return {
                label: "Cancelled - unavailable",
                className: "text-black90 text-15 font-semibold",
            };
        case helpers_1.OrderLineStatus.CANCELLED_REJECTED:
            return {
                label: "Cancelled - rejected",
                className: "text-black90 text-15 font-semibold",
            };
    }
};
exports.getOrderLineStatusLabel = getOrderLineStatusLabel;
